import { render, staticRenderFns } from "./delegaciones.vue?vue&type=template&id=dd31f262"
import script from "./delegaciones.vue?vue&type=script&lang=js"
export * from "./delegaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports